export const TIMETABLE = '/timetable/'
// export const TIMETABLE_UPDATED = `${TIMETABLE}updated` as const
export const TIMETABLE_ALL = `${TIMETABLE}all` as const
// export const TIMETABLE_GENERATE = `${TIMETABLE}generate` as const
export const TIMETABLE_GENERATE_UPDATED = `${TIMETABLE}generate/updated` as const
export const TIMETABLE_UPDATE_STATUS = `${TIMETABLE}update-slot-status` as const
export const TIMETABLE_HOURS_REPORT = `${TIMETABLE}hours-report` as const
